module.exports = __webpack_public_path__ + "media/images/app/testimonials/header-59ee6e0bb5d36f46512a39bf43114a5b.webp";